import { makeRawFetch } from '../common/utils';
import { makeChartUrl } from './_shared/urlMakers';

export const fetchChartEvents = makeRawFetch<any>(makeChartUrl);
